export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var JobType;
(function (JobType) {
    JobType["ACCOUNT_SYNC"] = "account-sync";
    JobType["CUR_DELTA"] = "cur-delta";
    JobType["CUSTOMER_ACCOUNT_ACTION"] = "customer-account-action";
    JobType["CUSTOMER_USAGE_CURSOR_FETCH"] = "customer-usage-cursor-fetch";
    JobType["CSV_REPORT_GENERATE"] = "csv-report-generate";
    JobType["ENVIRONMENT_SCAN"] = "environment-scan";
    JobType["GENERATE_INVOICE"] = "generate-invoice";
    JobType["RECONCILIATION"] = "reconciliation";
    JobType["SKU_IMPORT"] = "sku-import";
    JobType["USAGE_QUEUE_BUILD"] = "usage-queue-build";
})(JobType || (JobType = {}));
//# sourceMappingURL=common.js.map